import { render, staticRenderFns } from "./VideoRecorderSubtitles.vue?vue&type=template&id=733ac202&scoped=true&"
import script from "./VideoRecorderSubtitles.vue?vue&type=script&lang=js&"
export * from "./VideoRecorderSubtitles.vue?vue&type=script&lang=js&"
import style0 from "./VideoRecorderSubtitles.vue?vue&type=style&index=0&id=733ac202&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../voicecasting.sk/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "733ac202",
  null
  
)

export default component.exports